export default {
    title: state => {
        return state.title;
    },
    units: state => {
        return state.units;
    },
    unitsForCurrentUser: state => {
        return state.unitsForCurrentUser;
    },
    unit: state => {
        return state.unit;
    },
    section: state => {
        return state.section;
    },
    unitToEdit: state => {
        return state.unitToEdit;
    },
    total: state => {
        return state.total;
    },
    monitoringDoctors: state => {
        return state.monitoringDoctors;
    }
}
